import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { api } from "../../../config";

const Modal = ({ setOpenPopup, setPopup, openPopup, popup }) => {
  
  const { popupData } = useSelector((state) => state.catalog);


  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => (document.body.style.overflow = "visible");
  });

  useEffect(() => {
    if (!openPopup) {
      return;
    }

    function handleKeyUp(event) {
      switch (event.key) {
        case "Escape":
          setOpenPopup(!openPopup);
          setPopup(popupData);
          break;
      }
    }

    window.addEventListener("keyup", handleKeyUp);
    return () => window.removeEventListener("keyup", handleKeyUp);
  }, [openPopup]);

  return (
    <div className="modal">
      <div className="container">
        <div className="close-btn">
          <div
            className="btn"
            onClick={() => {
              return setOpenPopup(!openPopup), setPopup(popupData);
            }}
          >
            x
          </div>
        </div>
        <div className="content">
          {popup.map((item, i) => {

            const extension = item.fileName.split(".")[1];

            return (
              <div key={i} className="box">
                <div className="title">{item.titulo}</div>
                <div className="subtitle">{item.subtitulo}</div>

                <div className="image">
                  {item.type === "marca" && !item.hasvideo && (
                    <div>
                      {extension === "jpg" && (
                        <img
                          src={`${api.media.images}${
                            item.fileName.split(".")[0]
                          }`}
                        />
                      )}
                      {extension === "png" && (
                        <img
                          src={`${api.media.images}${
                            item.fileName.split(".")[0]
                          }`}
                        />
                      )}
                      {extension === "mp4" && (
                        <video controls>
                          <source
                            src={`${api.media.videos}${
                              item.fileName.split(".")[0]
                            }`}
                            type="video/mp4"
                          />
                        </video>
                      )}
                    </div>
                  )}
                  {item.type === "categoria" && !item.hasvideo && (
                    <div>
                      {extension === "jpg" && (
                        <img
                          src={`${api.media.images}${
                            item.fileName.split(".")[0]
                          }`}
                        />
                      )}
                      {extension === "png" && (
                        <img
                          src={`${api.media.images}${
                            item.fileName.split(".")[0]
                          }`}
                        />
                      )}
                      {extension === "mp4" && (
                        <video controls>
                          <source
                            src={`${api.media.videos}${
                              item.fileName.split(".")[0]
                            }`}
                            type="video/mp4"
                          />
                        </video>
                      )}
                    </div>
                  )}

                  {item.type === "grupo" && !item.hasvideo && (
                    <div>
                      {extension === "png" && (
                        <img
                          src={`${api.media.images}${
                            item.fileName.split(".")[0]
                          }`}
                        />
                      )}
                      {extension === "jpg" && (
                        <img
                          src={`${api.media.images}${
                            item.fileName.split(".")[0]
                          }`}
                        />
                      )}
                      {extension === "mp4" && (
                        <video controls>
                          <source
                            src={`${api.media.videos}${
                              item.fileName.split(".")[0]
                            }`}
                            type="video/mp4"
                          />
                        </video>
                      )}
                    </div>
                  )}

                  {item.hasvideo && popup.type === "grupo" && (
                    <video controls>
                      <source
                        src={`wp-json/ferrero/video/popup/popup-video-grupo-${
                          popup.code
                        }-${i + 1}`}
                        type="video/mp4"
                      />
                    </video>
                  )}
                  {item.hasvideo && popup.type === "marca" && (
                    <video controls>
                      <source
                        src={`wp-json/ferrero/video/popup/popup-video-marca-${
                          popup.code
                        }-${i + 1}`}
                        type="video/mp4"
                      />
                    </video>
                  )}

                  {item.hasvideo && popup.type === "category" && (
                    <video controls>
                      <source
                        src={`wp-json/ferrero/video/popup/popup-video-categoria-${
                          popup.code
                        }-${i + 1}`}
                        type="video/mp4"
                      />
                    </video>
                  )}
                </div>

                <div className="bottomText">{item.footer}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Modal;
